import { render } from "./CreateChampionsForm.vue?vue&type=template&id=d14e05ac&scoped=true"
import script from "./CreateChampionsForm.vue?vue&type=script&lang=js"
export * from "./CreateChampionsForm.vue?vue&type=script&lang=js"

import "./CreateChampionsForm.vue?vue&type=style&index=0&id=d14e05ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14e05ac"]])

export default __exports__